<!-- 角色授权(按角色) -- 从表 -->
<template>
  <div>
    <Table
      ref="table"
      :loadObj='{}'
      :option="{}"
      :colObj='{
        opId:"128",
        name:"角色授权明细",
        parentId:"TEAM_ID",
        parentName:"角色授权(按角色)",
        parentPath:"/system/userGroupAjs",
        dataClass:2,
        addClick
      }'
    >
    </Table>
    <m-selectorcc :visible.sync="select" :select='{
      searchslotType: "",
      searchslottitle: "请选择权限",
      multiple: true,
      searchslotId: 125,
      searchslotkey: { ID: "ID" },
      filterWhere:$route.query.TEAM_ID,//过滤
      colname:"ajssqxzqx",
    }' @listenEvent="fn"></m-selectorcc>
  </div>
</template>

<script>
import Table from "@/components/table/dataTablecSon";
import MSelectorcc from "@/components/table/MSelectorcc";
import { addShow } from "@/api/table/table";
export default {
  components: {
    Table,
    MSelectorcc,
  },
  data() {
    return {
      firstEnter:true,
      select:false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 新增打开选择器
    addClick(){
      this.select = true;
    },
    // 选择器 回填
    fn(e){
      console.log(e);
      this.select = false;
      addShow({
        opid: 128,
        dataClass: 2,
        data: {ROLE_ID:e.ID.join(","),TEAM_ID:this.$route.query.TEAM_ID},
        runId: this.$route.query.runId,
        otherCol:"ROLE_ID"
      }).then(res=>{
        this.$refs.table.$refs.child.onLoad();
      });
    },
  },
  created() {},
  mounted() {},
  activated() {
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  },
};
</script>

<style></style>